export default __webpack_public_path__ + "static/media/Olim1.fae83c49.png";